<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
          @click="showFormModal(null)"
          class="px-3 text-capitalize"
          variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد شهرهای کشور
        </b-button>
      </b-col>
    </b-row>
    <div>
      <div>
        <b-row>
          <per-page class="col-sm-12 col-md-3 col-lg-2" v-model="perPage" />

          <b-col sm="12" md="8">
            <b-input-group>
              <b-form-input
              
                v-model="searchInput"
                placeholder="برای جستجو نام شهرهای کشور را وارد کنید"
              />
             
            </b-input-group>
          </b-col>
          <b-col>
            <!-- <b-button variant="primary" block @click="searchBase()">
            <span v-if="submitLoading">
              <b-spinner small class="p-0 m-0" />
              <span class="sr-only">Loading...</span>
            </span>

            <div v-else class="text-capitalize">جستجو</div>
          </b-button> -->
          </b-col>
        </b-row>
      </div>

      <b-card body-class="p-0" class="mt-1">
        <table-head
          ref="capitalsTableHeadComponent"
          :items="tableHeadings"
          @sort="sort"
        />
        <b-row
          class="py-1 mx-1 border-bottom"
          v-for="capital in capitals"
          :key="capital.id"
        >
          <b-col class="d-flex align-items-center pl-0">
            {{ capital.name }}
          </b-col>
          <b-col class="d-flex align-items-center">
            <div v-for="(sate, i) in countries">
              <div v-if="sate.id === capital.country.name">
                {{ sate.name }}
              </div>
            </div>
          </b-col>

          <b-col
            class="d-flex align-items-center flex-row-reverse"
            style="direction: ltr"
          >
            {{
              new Date(capital.created_at).toLocaleString("fa-IR", {
                timeZone: "Iran",
              })
            }}
          </b-col>
          <b-col class="d-flex align-items-center">
            <b-button
              @click="showConfirmModal(capital)"
              variant="flat-danger"
              class="font-weight-bolder"
            >
              <feather-icon icon="Trash2Icon" size="20" />
            </b-button>
            <b-button
              @click="showFormModal(capital)"
              variant="flat-secondary"
              class="font-weight-bolder"
            >
              <feather-icon icon="Edit2Icon" size="20" />
            </b-button>
          </b-col>
        </b-row>
      </b-card>
      <pagination
        ref="capitalsPaginationComponent"
        v-model="page"
        :paginationData="paginationData"
      />
    </div>
    <b-sidebar
      width="98%"
      v-model="formModal"
      right
      backdrop
      shadow
      bg-variant="white"
      @shown="sliderShown"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
              style="background-color: rgba(75, 75, 75, 0.12)"
              @click="formModal = false"
              variant="flat-dark"
              class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش شهرهای کشور" : "ایجاد شهرهای کشور" }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class="row">
        <b-form-group class="mt-1 col-md-6">
          <label for="capital_country" class="text-capitalize"> کشور :</label>
          <v-select
            id="capital_country"
            :components="{ OpenIndicator }"
            class="bg-white"
            :clearable="false"
            v-model="capitalInput.country_id"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="name"
            :reduce="(country) => country.id"
            :options="countries"
            @search="getCapitals"
            placeholder="برای جستجو تایپ کنید"
          />
        </b-form-group>

        <b-form-group class="mt-1 col-md-6">
          <label for="name" class="text-capitalize"> نام : </label>
          <b-form-input id="name" v-model="capitalInput.name" type="text" />
        </b-form-group>
        <b-form-group class="mt-1 col-md-6">
          <label for="capital_slug" class="text-capitalize">اسلاگ| slug:</label>
          <b-form-input id="capital_slug" v-model="capitalInput.slug" type="text" />
        </b-form-group>
        <b-form-group class="mt-1 col-md-6" v-slot="{ ariaDescribedby }">
          <label for="country_status" class="text-capitalize"> وضعیت : </label>
          <b-form-radio
            v-model="capitalInput.status"
            :aria-describedby="ariaDescribedby"
            value="active"
            >فعال</b-form-radio
          >
          <b-form-radio
            v-model="capitalInput.status"
            :aria-describedby="ariaDescribedby"
            value="inactive"
            >پیش نویس</b-form-radio
          >
        </b-form-group>



        <b-form-group class="mt-1 col-md-6" v-slot="{ ariaDescribedby1 }">
          <label for="country_primary_capital" class="text-capitalize"> اولویت شهرهای کشورهای روم تور : </label>
          <b-form-radio
              v-model="capitalInput.primary_capital"
              value="active"
              :aria-describedby="ariaDescribedby1"
          >
            اولویت دار
          </b-form-radio
          >
          <b-form-radio
              v-model="capitalInput.primary_capital"
              :aria-describedby="ariaDescribedby1"
              value="inactive"
          >بدون اولویت</b-form-radio
          >
        </b-form-group>


        <b-form-group class="mt-1 col-md-6" v-slot="{ ariaDescribedby1 }">
          <label for="order_capital" class="text-capitalize"> شماره اولویت شهرهای کشورهای روم تور : </label>
          <b-form-input id="order_capital" v-model="capitalInput.order_capital" type="text" />
        </b-form-group>


        <b-form-group class="mt-1 col-md-6">
          <label for="capital_banner" class="text-capitalize"
            >آپلود بنر (600*1500):</label
          >
          <!-- <b-form-input
            id="capital_banner"
            v-model="capitalInput.banner"
            type="text"
          /> -->
          <FilePicker
            ref="bannerFilePicker"
            @inputFile="inputFile"
            :url="imageUrl"
          ></FilePicker>
        </b-form-group>
        <b-form-group class="mt-1 col-md-12">
          <label for="capital_description" class="text-capitalize">توضیحات:</label>
          <vue-editor
            v-model="capitalInput.description"
            :editorToolbar="customToolbar"
          ></vue-editor>
        </b-form-group>

        <b-form-group class="mt-1 col-md-12">
          <label for="capital_images" class="text-capitalize"
          >تصاویر شهرهای کشور (از طریق سرور دانلود لینک دانلود خوانده و با کاما, انگلیسی جدا سازی شود ,)</label
          >
          <b-form-textarea
              style="direction: ltr"
              rows="4"
              id="capital_images"
              v-model="capitalInput.images"
              type="text"
          />
        </b-form-group>
        <b-form-group class="mt-1 col-md-12">
          <label for="capital_videos" class="text-capitalize"
          >ویدیو های شهرهای کشور (از طریق سرور دانلود لینک دانلود خوانده و با کاما, انگلیسی جدا سازی شود ,)</label
          >
          <b-form-textarea
              style="direction: ltr"
              rows="4"
              id="capital_videos"
              v-model="capitalInput.videos"
              type="text"
          />
        </b-form-group>

        <b-form-group class="mt-1 col-md-12">
          <label for="capital_videos" class="text-capitalize"
          >پادکست های شهر (از طریق سرور دانلود لینک دانلود خوانده و با کاما, انگلیسی جدا سازی شود ,)</label
          >
          <b-form-textarea
              style="direction: ltr"
              rows="4"
              id="capital_videos"
              v-model="capitalInput.podcasts"
              type="text"
          />
        </b-form-group>

        <b-form-group class="mt-1 col-md-12">
          <label for="capital_videos" class="text-capitalize"
          >سوالات متداول شهر (انتهای سوال علامت ؟ و در انتهای پاسخ کام , قرار دهید)</label
          >
          <b-form-textarea
              rows="4"
              id="capital_videos"
              v-model="capitalInput.faqs"
              type="text"
          />
        </b-form-group>







      </b-container>
      <b-container>
        <b-row>
          <b-col>
            <b-form-group class="mt-1 col-md-12">
              <label for="capital_banner" class="text-capitalize"
              >طول جغرافیایی (lng):</label
              >
              <b-form-input
                  id="capital_banner"
                  v-model="capitalInput.lng"
                  type="text"
              />
            </b-form-group>
            <b-form-group class="mt-1 col-md-12">
              <label for="capital_banner" class="text-capitalize"
                >عرض جغرافیایی (lat):</label
              >
              <b-form-input
                id="capital_banner"
                v-model="capitalInput.lat"
                type="text"
              />
            </b-form-group>

            <b-button type="button" @click="searchLatLng()">جستجو</b-button>
          </b-col>
          <b-col md="6">
            <div  style="position: relative;">
              <l-map
                v-if="showMap"
                :zoom="zoom"
                :center="center"
                :options="mapOptions"
                style="height: 200px"
                @update:center="centerUpdate"
                @update:zoom="zoomUpdate"
                ref="mymap"
              >
                <l-tile-layer :url="url" :attribution="attribution" />
              </l-map>

              <feather-icon
                icon="MapPinIcon"
                size="20"
                fill="#FFF "
                style="
                  position: absolute;
                  top: 50%;
                  margin-top: -20px;
                  z-index: 9999;
                  left: 50%;
                  margin-left: -10px;
                "
              />
            </div>
          </b-col>
        </b-row>
      </b-container>
      <hr />

      <b-container class="row">
        <div class="sidebarHeaderTitleDiv col-md-12 mr-1">
          <h3 class="text-capitalize">تنظیمات سئو</h3>
        </div>
        <b-form-group class="mt-1 col-md-12">
          <label for="capital_seo_data_title" class="text-capitalize">
            عنوان SEO :</label
          >
          <b-form-input
            id="name"
            v-model="capitalInput.seo_data_title"
            type="text"
          />
        </b-form-group>

        <b-form-group class="mt-1 col-md-12">
          <label for="seo_data_keywords" class="text-capitalize">
            کلمات کلیدی (با "،" جدا شود) :
          </label>
          <b-form-textarea
            rows="1"
            id="seo_data_keywords"
            v-model="capitalInput.seo_data_keywords"
            type="text"
          />
        </b-form-group>
        <b-form-group class="mt-1 col-md-12">
          <label for="seo_data_description" class="text-capitalize"
            >توضیجات SEO:</label
          >
          <b-form-textarea
            rows="4"
            id="seo_data_description"
            v-model="capitalInput.seo_data_description"
            type="text"
          />
        </b-form-group>
        <b-form-group class="mt-1 col-md-12">
          <label for="seo_data_schema" class="text-capitalize"
            >schema SEO:</label
          >
          <b-form-textarea
            rows="4"
            id="seo_data_schema"
            v-model="capitalInput.seo_data_schema"
            type="text"
          />
        </b-form-group>
      </b-container>
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
            class="text-capitalize mr-2"
            @click="formModal = false"
            variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import { VueEditor } from "vue2-editor";
import L from "leaflet";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet";
import { Icon } from "leaflet";
import FilePicker from "@/components/FilePicker.vue";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    VueEditor,
    BFormRadio,
    FilePicker,
    BInputGroup,
  BInputGroupAppend,
  },
  data() {
    return {
      imageUrl: "",
      lat: 29.591768,
      lng: 52.583698,
      zoom: 13,
      center: latLng(29.591768, 52.583698),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 13,
      currentCenter: latLng(29.591768, 52.583698),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
      },

      showMap: true,

      customToolbar: [
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6],
          },
        ],
        [
          {
            align: "",
          },
          {
            align: "center",
          },
          {
            align: "right",
          },
          {
            align: "justify",
          },
        ],
        [
          {
            indent: "-1",
          },
          {
            indent: "+1",
          },
        ],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
      perPage: 10,
      page: 1,
      countries: [],
      capitals: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      tableHeadings: [
        {
          title: "نام",
          slug: "name",
          sortable: true,
        },
        {
          title: "نام کشور",
          slug: "country_name",
          sortable: true,
        },
        {
          title: "تاریخ ایجاد",
          slug: "created_at",
          sortable: true,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
          createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      companies: [],
      countriesCancelToken: undefined,
      capitalInput: {
        id: "",
        country_id: "",
        name: "",
        slug: "",
        status: "active",
        primary_capital: "inactive",
        description: "",
        order_capital: "",
        images: "",
        videos: "",
        podcasts: "",
        faqs: "",
        lat: "",
        lng: "",
        seo_data_title: "",
        seo_data_keywords: "",
        seo_data_description: "",
        seo_data_schema: "",
        banner: null,
      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getCapitals();
    this.getCountries();
  },
  watch: {
    searchInput(value) {
      this.page = 1;
      this.getCapitals();
    },
    perPage(value) {
      this.page = 1;
      this.getCapitals();
    },
    page(value) {
      this.getCapitals();
    },
  },
  methods: {
    inputFile(file) {
      this.capitalInput.banner = file;
    },
    searchLatLng() {
      this.center = latLng(this.capitalInput.lat, this.capitalInput.lng);
    },
    sliderShown() {
      setTimeout(() => {
        //mapObject is a property that is part of leaflet
        this.$refs.mymap.mapObject.invalidateSize();
      }, 100);
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;

      console.log("center", center);
      this.capitalInput.lat = center.lat;
      this.capitalInput.lng = center.lng;
      this.center = latLng(this.capitalInput.lat, this.capitalInput.lng);
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    innerClick() {
      alert("Click!");
    },

    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getCapitals();
    },

    async getCapitals() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        "filter[name]": this.searchInput,
        // 'filter[slug]':this.searchInput,
        // per_page: this.perPage,
        page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/capitals",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data;
          this.capitals = data.data;
          this.paginationData = data.meta;
        })
        .catch((err) => {
          console.log(err);
        });
    },
   
    showConfirmModal(capital) {
      this.$bvModal
        .msgBoxConfirm(`آیا از حذف شهر مطمئن هستید ؟  : ${capital.name}.`, {
          title: this.$t("Please Confirm"),
          size: "sm",
          okVariant: "primary",
          okTitle: this.$t("Yes"),
          cancelTitle: this.$t("No"),
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (confirmed) => {
          if (confirmed) {
            let capitalIndex = 0;
            this.capitals = await this.capitals.filter((capitalItem, index) => {
              if (capitalItem.id == capital.id) {
                capitalIndex = index;
              }
              return capitalItem.id !== capital.id;
            });

            const requestData = {
              method: "delete",
              url: `/admin/capitals/${capital.id}`,
            };
            this.$http(requestData)
              .then((response) => {
                this.$bvToast.toast(`شهر: ${capital.name} با موفقیت حذف شد.`, {
                  title: this.$t("Done"),
                  variant: "success",
                  solid: true,
                });
              })
              .catch((err) => {
                let message = this.$t("Unable to delete!");
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                )
                  message = err.response.data.message;
                this.$bvToast.toast(message, {
                  title: this.$t("Error"),
                  variant: "danger",
                  solid: true,
                });
                this.capitals.splice(capitalIndex, 0, capital);
              });
          }
        });
    },
    showFormModal(capital) {
      if (capital) {
        this.capitalInput = {
          id: capital.id,
          country_id: capital.country.id,
          name: capital.name,
          slug: capital.slug,
          status: capital.status,
          primary_capital: capital.primary_capital,
          description: capital.description,
          order_capital: capital.order_capital,
          images: capital.images,
          videos: capital.videos,
          podcasts: capital.podcasts,
          faqs: capital.faqs,
          lat: capital.lat,
          lng: capital.lng,
          seo_data_title: capital.seo_data.title,
          seo_data_keywords: capital.seo_data.keywords,
          seo_data_description: capital.seo_data.description,
          seo_data_schema: capital.seo_data.schema,
          banner: capital.banner,
        };
        this.$refs.bannerFilePicker.clearFileInput();
        this.searchLatLng();
        this.imageUrl = capital.banner.path;
        this.editMode = true;
      } else {
        this.capitalInput = {
          id: "",
          country_id: "",
          name: "",
          slug: "",
          status: "active",
          primary_capital:"inactive",
          description: "",
          order_capital: "",
          images: "",
          videos: "",
          podcasts: "",
          faqs: "",
          lat: "",
          lng: "",
          seo_data_title: "",
          seo_data_keywords: "",
          seo_data_description: "",
          seo_data_schema: "",
          banner: null,
        };
        this.$refs.bannerFilePicker.clearFileInput();
        this.imageUrl = "";
        this.editMode = false;
      }
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
      let errorMessage = null;
      if (!errorMessage && !this.capitalInput.country_id) {
        errorMessage = "لطفا یک کشور را انتخاب کنید";
      }
      if (!errorMessage && !this.capitalInput.name) {
        errorMessage = "لطفا نام را وارد کنید";
      }
      if (!errorMessage && this.capitalInput.name.length < 2) {
        errorMessage = "نام نمی تواند کمتر از 2 کاراکتر باشد";
      }
      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      let formData = new FormData();
      if (this.capitalInput.country_id) {
        formData.append("country_id", this.capitalInput.country_id);
      }
      if (this.capitalInput.name) {
        formData.append("name", this.capitalInput.name);
      }
      if (this.capitalInput.slug) {
        formData.append("slug", this.capitalInput.slug);
      }
      if (this.capitalInput.status) {
        formData.append("status", this.capitalInput.status);
      }
      if (this.capitalInput.primary_capital) {
        formData.append("primary_capital", this.capitalInput.primary_capital);
      }
      if (this.capitalInput.description) {
        formData.append("description", this.capitalInput.description);
      }
      if (this.capitalInput.order_capital) {
        formData.append("order_capital", this.capitalInput.order_capital);
      }
      if (this.capitalInput.images) {
        formData.append("images", this.capitalInput.images);
      }
      if (this.capitalInput.videos) {
        formData.append("videos", this.capitalInput.videos);
      }
      if (this.capitalInput.podcasts) {
        formData.append("podcasts", this.capitalInput.podcasts);
      }
      if (this.capitalInput.faqs) {
        formData.append("faqs", this.capitalInput.faqs);
      }
      if (this.capitalInput.lat) {
        formData.append("lat", this.capitalInput.lat);
      }
      if (this.capitalInput.lng) {
        formData.append("lng", this.capitalInput.lng);
      }
      if (this.capitalInput.seo_data_title) {
        formData.append("seo_data_title", this.capitalInput.seo_data_title);
      }
      if (this.capitalInput.seo_data_keywords) {
        formData.append("seo_data_keywords", this.capitalInput.seo_data_keywords);
      }
      if (this.capitalInput.seo_data_description) {
        formData.append(
          "seo_data_description",
          this.capitalInput.seo_data_description
        );
      }
      if (this.capitalInput.seo_data_schema) {
        formData.append("seo_data_schema", this.capitalInput.seo_data_schema);
      }
      if (this.capitalInput.banner) {
        formData.append("banner", this.capitalInput.banner);
      }

      console.log( this.capitalInput.primary_capital);
      const requestData = {
        method: this.editMode ? "post" : "post",
        url: this.editMode
          ? `/admin/capitals/update/${this.capitalInput.id}`
          : `/admin/capitals`,
        data: formData,
      };

      this.$http(requestData)
        .then((response) => {
          let message = "شهر با موفقیت اضافه شد";
          if (this.editMode) message = "شهر با موفقیت ویرایش شد";
          this.$bvToast.toast(message, {
            title: this.$t("Done"),
            variant: "success",
            solid: true,
          });
          if (!this.editMode && this.countries && this.countries.length > 0) {
            this.$refs.capitalsPaginationComponent.clear();
            // this.$refs.capitalsSearchComponent.clear();
            this.$refs.capitalsTableHeadComponent.clear();
            this.page = 1;
            this.searchInput = "";
            this.sortBy = "";
            this.sortDir = "";
          }

          this.submitLoading = false;
          this.formModal = false;
          this.getCapitals();
        })
        .catch((err) => {
          let message = "خطا در ایجاد شهر";
          if (this.editMode) message = "خطا در ویرایش شهر";
          if (err.response && err.response.data && err.response.data.message)
            message = err.response.data.message;

          this.$bvToast.toast(message, {
            title: this.$t("Error"),
            variant: "danger",
          });
          this.submitLoading = false;
          console.log(err);
        });
    },
    getCountries(search, loading) {
      if (typeof this.countriesCancelToken != typeof undefined) {
        this.countriesCancelToken.cancel(
          "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.countriesCancelToken = this.$http.CancelToken.source();

      let data = {
        //paginate: true,
        //  this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/countries",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data;
          this.countries = data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
